/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Input from '@components/form/Input';
import Colors from '@global/colors';
import Image from '@components/global/Image';
import SelectBox from '@components/form/SelectBox';
import SociollaText from '@components/sociolla/SociollaText';
import { selectParams } from '@/store/params';

const SearchInputMobile = (props) => {
  const testID = props.testID || 'search-input-mobile';
  const filterName = props.filterName ? props.filterName : null;
  const paramsState = useSelector(selectParams(filterName)); // existing parameters for filter
  const searchKey = props.searchKey ? props.searchKey : null;
  const noHorizontal = props.noHorizontal ? true : false;
  const noBorderBottom = props.noBorderBottom ? true : false;
  const searchForOptions = props.searchForOptions
    ? props.searchForOptions
    : false; // enable search for feature B2B-3696
  const isHasSearchOptions =
    Array.isArray(searchForOptions) && searchForOptions.length > 1;

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (props.value !== undefined && props.value !== null) {
        setKeyword(props.value);
      } else if (searchKey && paramsState?.filter[searchKey]) {
        if (paramsState?.filter[searchKey]?.$regex) {
          setKeyword(paramsState.filter[searchKey].$regex);
        } else {
          setKeyword(paramsState.filter[searchKey]);
        }
      } else if (searchKey && !paramsState?.filter[searchKey]) {
        setKeyword('');
      }
      if (paramsState?.filter?.search_for) {
        setKeywordFor(paramsState?.filter?.search_for);
      }
      if (props.valueFor) {
        setKeywordFor(props.valueFor);
      }
    }
    return () => {
      mounted = false;
    };
  }, [paramsState, props.value, props.valueFor, searchKey]);

  const [keywords, setKeyword] = useState('');
  const [keywordsFor, setKeywordFor] = useState('');

  const onSearch = (value) => {
    setKeyword(value);
    try {
      props.onSearch(value, keywordsFor);
    } catch (error) {}
  };

  const onBlur = () => {
    try {
      props.onBlur();
    } catch (error) {}
  };

  const hasScanButton = props.onScan !== undefined;
  const scannedEAN = props.scannedEAN;
  const onRemoveScannedEAN = props.onRemoveScannedEAN;

  return (
    <View
      testID={testID}
      style={[
        styles.filter,
        noHorizontal ? styles.noHorizontal : {},
        noBorderBottom ? styles.noBorderBottom : {},
        isHasSearchOptions ? styles.hasSearchOptions : {},
      ]}>
      <Input
        testID={`${testID}-input`}
        label=""
        {...props}
        value={scannedEAN ? '' : keywords}
        editable={!scannedEAN}
        placeholder={props.placeholder ? props.placeholder : 'Search something'}
        onBlur={() => onBlur()}
        containerStyle={[
          isHasSearchOptions ? { flex: 1, minWidth: 0, marginRight: 8 } : {},
        ]}
        leftIcon={
          scannedEAN ? (
            <View style={styles.eanBubble}>
              <SociollaText style={styles.eanBubbleText}>
                {scannedEAN}
              </SociollaText>
              <TouchableOpacity
                activeOpacity={0.7}
                onPress={() => {
                  if (onRemoveScannedEAN) {
                    onRemoveScannedEAN();
                  }
                }}
                style={styles.eanBubbleClose}>
                <Image
                  style={{ width: 12, height: 12 }}
                  width={12}
                  height={12}
                  svg={true}
                  source={require('@assets/img/icons/close-grey.svg')}
                />
              </TouchableOpacity>
            </View>
          ) : null
        }
        rightIcon={
          scannedEAN ? (
            <TouchableOpacity
              activeOpacity={0.7}
              onPress={() => {
                if (onRemoveScannedEAN) {
                  onRemoveScannedEAN();
                }
              }}>
              <Image
                // eslint-disable-next-line react-native/no-inline-styles
                style={{ width: 16, height: 16 }}
                width={16}
                height={16}
                svg={true}
                source={require('@assets/img/icons/close-circle-grey.svg')}
              />
            </TouchableOpacity>
          ) : keywords ? (
            <TouchableOpacity
              testID={`${testID}-clear-btn`}
              activeOpacity={1}
              onPress={() => onSearch('')}>
              <Image
                // eslint-disable-next-line react-native/no-inline-styles
                style={{ width: 16, height: 16 }}
                width={16}
                height={16}
                svg={true}
                source={require('@assets/img/icons/close-circle-grey.svg')}
              />
            </TouchableOpacity>
          ) : hasScanButton ? (
            <TouchableOpacity
              testID={`${testID}-scan-btn`}
              activeOpacity={0.7}
              onPress={() => {
                if (props.onScan) {
                  props.onScan();
                }
              }}>
              <Image
                // eslint-disable-next-line react-native/no-inline-styles
                style={{ width: 16, height: 16 }}
                width={16}
                height={16}
                svg={true}
                source={require('@assets/img/icons/scan.svg')}
              />
            </TouchableOpacity>
          ) : (
            <Image
              // eslint-disable-next-line react-native/no-inline-styles
              style={{ width: 16, height: 16 }}
              width={16}
              height={16}
              svg={true}
              source={require('@assets/img/icons/search.svg')}
            />
          )
        }
        onChangeText={(keywords) => onSearch(keywords)}
      />
      {isHasSearchOptions && (
        <View style={{ width: 170, flexShrink: 0 }}>
          <SelectBox
            testID={`${testID}-select`}
            label={'Search For'}
            hideLabel
            hideSearch
            options={searchForOptions}
            placeholder="Search For"
            trackBy="value"
            labelKey="label"
            formLabelKey="label"
            value={keywordsFor}
            onChange={(value) => setKeywordFor(value)}
            // SelectBox defaults to width 300; make it fill the 170 wrapper so its
            // dropdown arrow isn't clipped.
            style={{ width: '100%' }}
          />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  filter: {
    width: '100%',
    backgroundColor: Colors.white,
    paddingHorizontal: 10,
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: Colors.grey0,
  },
  noHorizontal: { paddingHorizontal: 0 },
  noBorderBottom: { borderBottomColor: Colors.transparent },
  hasSearchOptions: { flexDirection: 'row', alignItems: 'center' },
  eanBubble: {
    backgroundColor: Colors.blue6,
    paddingHorizontal: 12,
    paddingVertical: 7,
    borderRadius: 12,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  eanBubbleText: {
    fontSize: 11,
    marginRight: 8,
    color: Colors.grey1,
  },
  eanBubbleClose: {
    padding: 2,
  },
});

export default SearchInputMobile;
